import { useEffect } from 'react';

/**
 * PWA Analytics Tracker
 * Tracks PWA installation events and sends them to Umami
 */
export function usePWATracking() {
  useEffect(() => {
    // Track when install prompt is shown
    const handleBeforeInstall = (e) => {
      // Track that user was shown install prompt
      if (window.umami) {
        window.umami.track('pwa-install-prompt-shown');
      }
    };

    // Track successful installation
    const handleAppInstalled = () => {
      if (window.umami) {
        window.umami.track('pwa-installed');
      }
      // Also save to localStorage to identify installed users
      localStorage.setItem('pwa-installed', 'true');
      localStorage.setItem('pwa-install-date', new Date().toISOString());
    };

    // Track if user is using installed PWA (standalone mode)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches 
      || window.navigator.standalone === true;
    
    if (isStandalone) {
      // Only track once per session
      if (!sessionStorage.getItem('pwa-session-tracked')) {
        if (window.umami) {
          window.umami.track('pwa-app-opened');
        }
        sessionStorage.setItem('pwa-session-tracked', 'true');
      }
    }

    // Track push notification subscription
    const trackPushSubscription = () => {
      if (window.umami) {
        window.umami.track('push-notifications-enabled');
      }
    };

    // Listen for events
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    window.addEventListener('appinstalled', handleAppInstalled);

    // Expose function for manual tracking
    window.trackPushSubscription = trackPushSubscription;

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);
}

export default usePWATracking;
